import { PhotoAsset } from "../types";

export const normalizePhotoAsset = (asset: any): PhotoAsset | null => {
  if (!asset) return null;
  const type = String(asset.type || "").toLowerCase();
  if (type !== "photo") return null;
  return {
    id: String(asset.id || ""),
    type: "photo",
    url: asset.url ?? null,
    createdAt: asset.createdAt ?? asset.created_at ?? "",
    uploadedBy: asset.uploadedBy ?? asset.uploaded_by ?? null,
    machineId: asset.machineId ?? asset.machine_id ?? undefined,
    locationId: asset.locationId ?? asset.location_id ?? undefined,
  };
};

export const normalizePhotoAssets = (assets: any): PhotoAsset[] =>
  Array.isArray(assets)
    ? assets
        .map(normalizePhotoAsset)
        .filter((asset): asset is PhotoAsset => Boolean(asset?.id))
    : [];
